export interface CheckboxProps {
  checked: boolean
  onCheckedChange: (checked: boolean) => void
}

export function Checkbox({ checked, onCheckedChange }: CheckboxProps) {
  return (
    <button
      type='button'
      role='checkbox'
      aria-checked={checked}
      onClick={() => onCheckedChange(!checked)}
      className='flex shrink-0 items-center justify-center size-[36px] rounded-[12px] border-0 bg-transparent p-0 cursor-pointer'
    >
      <div className='relative shrink-0 size-[16px]'>
        {checked ? (
          <svg
            viewBox='0 0 14 14'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className='w-full h-full'
          >
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M0 6.66667C0 2.98477 2.98477 0 6.66667 0C10.3486 0 13.3333 2.98477 13.3333 6.66667C13.3333 10.3486 10.3486 13.3333 6.66667 13.3333C2.98477 13.3333 0 10.3486 0 6.66667ZM10.1381 4.80474L9.19526 3.86193L5.33333 7.72386L3.80474 6.19526L2.86193 7.13807L5.33333 9.60948L10.1381 4.80474Z'
              fill='#65558F'
            />
          </svg>
        ) : (
          <svg
            viewBox='0 0 14 14'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className='w-full h-full'
          >
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M6.66667 1.33333C3.72115 1.33333 1.33333 3.72115 1.33333 6.66667C1.33333 9.61219 3.72115 12 6.66667 12C9.61219 12 12 9.61219 12 6.66667C12 3.72115 9.61219 1.33333 6.66667 1.33333ZM0 6.66667C0 2.98477 2.98477 0 6.66667 0C10.3486 0 13.3333 2.98477 13.3333 6.66667C13.3333 10.3486 10.3486 13.3333 6.66667 13.3333C2.98477 13.3333 0 10.3486 0 6.66667ZM10.1381 4.80474L5.33333 9.60948L2.86193 7.13807L3.80474 6.19526L5.33333 7.72386L9.19526 3.86193L10.1381 4.80474Z'
              fill='rgba(38, 38, 38, 0.2)'
            />
          </svg>
        )}
      </div>
    </button>
  )
}
